module.exports = __webpack_public_path__ + "assets/img/6fd51bc6dbec57a9a45b53f9ebce9422.svg";